import { UserDTO } from '../DTO/userDTO';
import { Customer } from './customer';
import { UserRole } from './userRole';
import { Vendor } from './vendor';

export class User
{
    public id! : number;
    public firstName! :string;
    public lastName! : string;
    public email! : string;
    public phoneNumber? : string;
    public confirmedTermsAndConditions? : Date;
    public role! : UserRole;
    public customerId?  : number;
    public customerName? : string;
    public vendorId? : number;
    public vendorName? : string;
    public lockoutEnabled? : boolean;
    public twoFactorEnabled? : boolean;
    public canBeDeleted? : boolean;
    public deleted? : boolean;
    public lastPasswordChange? : Date;

    private _customer? : Customer;
    private _vendor? : Vendor;
   
    public static mapFromDTO(param:UserDTO):User{ 
        if (!param || !param.id) throw new Error("parameter is null")
        let obj = new User();
        try
        {
            obj.id = param.id;
            obj.firstName = param.firstName;
            obj.lastName = param.lastName;
            obj.email = param.email;
            obj.phoneNumber = param.phoneNumber;
            if(param.confirmedTermsAndConditions) obj.confirmedTermsAndConditions = new Date(param.confirmedTermsAndConditions);
            obj.role = UserRole.mapFromDTO(param.role);
            obj.customerId = param.customerId;
            obj.customerName = param.customerName;
            obj.vendorId = param.vendorId;
            obj.vendorName = param.vendorName;
            obj.lockoutEnabled = param.lockoutEnabled;
            obj.twoFactorEnabled = param.twoFactorEnabled;
            obj.canBeDeleted = param.canBeDeleted;
            obj.deleted = param.deleted;
            if(param.lastPasswordChange) obj.lastPasswordChange = new Date(param.lastPasswordChange);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:User):UserDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new UserDTO();
        try
        {
            dto.id = param.id;
            dto.firstName = param.firstName;
            dto.lastName = param.lastName;
            dto.email = param.email;
            dto.phoneNumber = param.phoneNumber;
            if(param.confirmedTermsAndConditions) dto.confirmedTermsAndConditions = param.confirmedTermsAndConditions.toISOString();
            dto.role = UserRole.mapToDTO(param.role);
            dto.customerId = param.customerId;
            dto.customerName = param.customerName;
            dto.vendorId = param.vendorId;
            dto.vendorName = param.vendorName;
            dto.lockoutEnabled = param.lockoutEnabled;
            dto.twoFactorEnabled = param.twoFactorEnabled;
            dto.canBeDeleted = param.canBeDeleted;
            dto.deleted = param.deleted;
            if(param.lastPasswordChange) dto.lastPasswordChange = param.lastPasswordChange.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    get fullName():string{
        return this.firstName + ' ' + this.lastName;
    }

    get isSuperAdmin():boolean{
        return this.role.id==10;
    }

    get isCustomerAdmin():boolean{
        return this.role.id==20;
    }

    get isVendorAdmin():boolean{
        return this.role.id==50;
    }

    get isAnAdministrator():string{
        return (this.role.id==10 || this.role.id==20 || this.role.id==50)?'Yes':'No';
    }

    get isMfaEnabled():string{
        return (this.twoFactorEnabled)?'Yes':'No';
    }

    get canAddUsers():boolean{
        return (this.role.id==10 || this.role.id==20 || this.role.id==50); //more to be added probably
    }

    get canAddCustomers():boolean{
        return (this.role.id==10 || this.role.id==20); //more to be added probably
    }

    get canEditCustomer():boolean{
        return (this.role.id==20); //more to be added probably
    }

    get canEditVendor():boolean{
        return (this.role.id==50); //more to be added probably
    }

    get canEditPlatformSettings():boolean{
        return (this.role.id==10)
    }

    set customer(value:Customer | undefined){
        this._customer=value;
    }
    get customer():Customer | undefined{
        return this._customer;
    }

    set vendor(value:Vendor | undefined){
        this._vendor=value;
    }
    get vendor():Vendor | undefined{
        return this._vendor;
    }

    get entityType():string | undefined{
        return (this.customerId && this.customerId>0)?"C":((this.vendorId && this.vendorId>0)?"V":undefined);
    }
    get entityId():number | undefined{
        return (this.customerId && this.customerId>0)?this.customerId:((this.vendorId && this.vendorId>0)?this.vendorId:undefined);
    }
}